// extracted by mini-css-extract-plugin
module.exports = {"customTable":"TestTable_customTable__2kDCv","customRow":"TestTable_customRow__2XfxA","sidePanel":"TestTable_sidePanel___r4Eu"};